import React from "react";
import { Printer } from "lucide-react";

// A read-only "Print / Save PDF" trigger. Hidden automatically in the printout
// via the global `button { display:none }` print rule.
export const PrintButton = ({ label = "Print Report", testId = "print-report-btn", className = "" }) => (
  <button
    onClick={() => window.print()}
    data-testid={testId}
    className={`no-print inline-flex items-center gap-2 text-[13px] font-medium text-zinc-300 hover:text-white border border-zinc-700 hover:border-zinc-500 bg-zinc-900 hover:bg-zinc-800 px-3 py-2 rounded-md transition-colors ${className}`}
  >
    <Printer className="h-4 w-4" /> {label}
  </button>
);
